export const APPLICATION_NAME = 'RINGLEADERVENDORPORTAL';
export const APPLICATION_NAME_NORMAL = 'Ring Leader Vendor Portal';
export const LOCAL_STORAGE_ACCESS_TOKEN = `${APPLICATION_NAME}_ACCESS_TOKEN`;
export const LOCAL_STORAGE_REFRESH_TOKEN = `${APPLICATION_NAME}_REFRESH_TOKEN`;
export const LOCAL_STORAGE_PHONE_COUNTRY = `${APPLICATION_NAME}_PHONE_COUNTRY`;
export const LOCAL_STORAGE_SELECTED_LOCALE = `${APPLICATION_NAME}_SELECTED_LOCALE`;
export const SESSION_STORAGE_SELECTED_LOCALE = `${APPLICATION_NAME}_SELECTED_LOCALE`;
export const googlePlacesKey = 'AIzaSyCR388mWBleCqk4xOU2ZBjoBM_Aiu6VNt4';

export const SPLASH_SCREEN_DURATION_IN_MILLS = 400;

export const keyboardTypeEnum = {
  default: 'default',
  email: 'email-address',
  numeric: 'number-pad',
  decimal: 'decimal-pad',
  phone: 'phone-pad',
};

export const MAX_FILE_SIZE_IN_BYTES = 5000;

export const UPLOAD_ALLOWED_EXTENSIONS = ['png', 'jpg', 'jpeg'];

export const GENDERS = [
  { text: 'Male', value: 'male' },
  { text: 'Female', value: 'female' },
];

export const DOCUMENT_CREATOR = {
  USER: 'user',
  VENDOR: 'vendor',
};

export const CLIENT_STATUS = {
  ACCEPTED: 'accepted',
  COMPLETED: 'completed',
  LEAD: 'lead',
};

export const ORDER = { ASC: 'ASC', DESC: 'DESC' };

export const UPLOAD_PHOTO_ALLOWED_EXTENSIONS = ['png', 'jpeg', 'jpg'];

export const DOCUMENT_MEDIA_TYPE = {
  pdf: 'pdf',
  photo: 'photo',
};

export const WORKING_HOURS = {
  mon_1_open: '',
  mon_1_close: '',
  tue_1_open: '',
  tue_1_close: '',
  wed_1_open: '',
  wed_1_close: '',
  thu_1_open: '',
  thu_1_close: '',
  fri_1_open: '',
  fri_1_close: '',
  sat_1_open: '',
  sat_1_close: '',
  sun_1_open: '',
  sun_1_close: '',
};

export const DAYS = [
  { id: 'sun', name: 'Sunday', selected: true, number: 0 },
  { id: 'mon', name: 'Monday', selected: true, number: 1 },
  { id: 'tue', name: 'Tuesday', selected: true, number: 2 },
  { id: 'wed', name: 'Wednesday', selected: true, number: 3 },
  { id: 'thu', name: 'Thursday', selected: true, number: 4 },
  { id: 'fri', name: 'Friday', selected: true, number: 5 },
  { id: 'sat', name: 'Saturday', selected: true, number: 6 },
];

export const SLOTS = [
  { id: 1, title: '07:00 AM', value: '7' },
  { id: 2, title: '08:00 AM', value: '8' },
  { id: 3, title: '09:00 AM', value: '9' },
  { id: 4, title: '10:00 AM', value: '10' },
  { id: 5, title: '11:00 AM', value: '11' },
  { id: 6, title: '12:00 PM', value: '12' },
  { id: 7, title: '01:00 PM', value: '13' },
  { id: 8, title: '02:00 PM', value: '14' },
  { id: 9, title: '03:00 PM', value: '15' },
  { id: 10, title: '04:00 PM', value: '16' },
  { id: 11, title: '05:00 PM', value: '17' },
  { id: 12, title: '06:00 PM', value: '18' },
  { id: 13, title: '07:00 PM', value: '19' },
];

export const SLOTS_TYPE = {
  APPOINTMENT: 'appointment',
  UNAVAILABLE: 'unavailable',
};

export const CHAT_MESSAGE_TYPES = {
  PLAIN_TEXT: 'plainText',
  PHOTO: 'photo',
  VIDEO: 'video',
};

export const SOCKET_EVENTS = {
  JOIN_ROOM: 'joinRoom',
  SEND_MESSAGE: 'sendMessage',
  SEND_MESSAGE_STATUS: 'sendMessageStatus',
  RECEIVE_MESSAGE: 'receiveMessage',
  ERROR: 'error',
  CONNECT: 'connect',
  MESSAGE_SEEN: 'messageSeen',
  FETCH_DATA: 'fetchData',
  FETCH_ALL_DATA: 'fetchAllData',
};

export const SENDER_TYPE = {
  USER: 'user',
  VENDOR: 'vendor',
};

export const NOTIFICATION_TYPE = {
  REQUEST_ACCEPTED: 'request-accepted',
  REQUEST_SENT: 'request-sent',
  REQUEST_REJECTED: 'request-rejected',
  APPOINTMENT_CREATED: 'appointment-created',
  APPOINTMENT_DELETED: 'appointment-deleted',
  TODO_CREATED: 'toDo-created',
  PAYMENT_CREATED: 'payment-created',
  APPOINTMENT_REQUEST: 'appointment-request',
  DELETE_WEDDING_VENDOR: 'delete-wedding-vendor',
  ACCEPTED_DELETE_WEDDING_VENDOR: 'accepted-delete-wedding-vendor',
};

export const NOTIFICATION_STATUS = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
};

export const CLIENT_STATUSES = [
  { id: 1, value: 'accepted', label: 'Active' },
  { id: 2, value: 'completed', label: 'Completed' },
  { id: 3, value: 'lead', label: 'Lead' },
];

export const RENEW_CODE_TYPE = {
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
};

export const QUESTION_TYPE = {
  TEXT: 'text',
  MULTIPLE: 'multiple',
};

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const APPOINTMENT_TYPE = {
  APPOINTMENT: 'appointment',
  UNAVAILABLE: 'unavailable',
  LEAD: 'lead',
};

export const GOOGLE_API_KEY = 'AIzaSyCK7URSwd_exxIxP_BmOYnvbv01wyzhIw4';

export const GOOGLE_API_LIBRARY = ['places'];

export const GOOGLE_ANALYTICS_TRACKING_ID = 'G-XFLYRWYVZ1';
